import { useState } from "react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Hide,
  Input,
  InputSize,
  Show
} from "shared/components";
import { FilterIcon, PlusSignIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Switch, SwitchSize } from "shared/components/forms/Switch";
import { TaskOptions } from "../constants";
import { AssigneeFilterPopover } from "../slices/AssigneeFilterPopover";
import { TaskDrawer } from "../slices/TaskDrawer";

export const TaskTableHeader = ({
  search,
  setSearch,
  showCompletedTasks,
  setShowCompletedTasks,
  onFiltersClick,
  selectedAssigneeIds,
  onSelectedAssigneeIdsChange,
  isCreateTaskDrawerOpen,
  setIsCreateTaskDrawerOpen,
  onCreated,
  hasHeaderTitle = false,
  hideFilters = false
}: {
  search: string;
  setSearch: (search: string) => void;
  showCompletedTasks: boolean;
  setShowCompletedTasks: (show: boolean) => void;
  onFiltersClick: () => void;
  selectedAssigneeIds: number[];
  onSelectedAssigneeIdsChange: (ids: number[]) => void;
  isCreateTaskDrawerOpen: boolean;
  setIsCreateTaskDrawerOpen: (isOpen: boolean) => void;
  onCreated: () => void;
  hasHeaderTitle?: boolean;
  hideFilters?: boolean;
}) => {
  const [isAssigneeFilterOpen, setIsAssigneeFilterOpen] = useState(false);
  return (
    <header>
      <Show if={hasHeaderTitle}>
        <h1 className="text-2xl font-bold text-content-1000 mb-6">Tasks</h1>
      </Show>
      <div className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <Input
            id="search"
            label=""
            placeholder="Search tasks"
            wrapperClassName="w-full md:w-auto"
            className="!mb-0 w-full lg:min-w-[271px] !h-10"
            size={InputSize.BASE}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />

          <Hide if={hideFilters}>
            <Button
              HugeIcon={FilterIcon}
              size={ButtonSize.SM}
              className="!max-w-10 w-full !items-center !justify-center !gap-0"
              onClick={onFiltersClick}
              aria-label={TaskOptions.filters}
            />
          </Hide>
          <AssigneeFilterPopover
            open={isAssigneeFilterOpen}
            onOpenChange={setIsAssigneeFilterOpen}
            selectedUserIds={selectedAssigneeIds}
            onSelectedUserIdsChange={onSelectedAssigneeIdsChange}
            onPageChange={() => {}}
          />
          <div className="ml-auto hidden md:flex md:items-center md:gap-2 shrink-0 md:w-auto w-full">
            <div className="flex items-center gap-4">
              <Switch
                label="Show completed tasks"
                size={SwitchSize.BASE}
                checked={showCompletedTasks}
                onChange={() => {
                  setShowCompletedTasks(!showCompletedTasks);
                }}
              />
              <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.SM}
                HugeIcon={PlusSignIcon}
                className="m-auto"
                onClick={() => setIsCreateTaskDrawerOpen(true)}
              >
                {TaskOptions.create}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <TaskDrawer
        open={isCreateTaskDrawerOpen}
        mode="create"
        onClose={() => setIsCreateTaskDrawerOpen(false)}
        onCreated={onCreated}
      />
    </header>
  );
};
